/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {UiComponentConfig} from "../../generated/UiComponentConfig";
import {UiSplitPane} from "../UiSplitPane";
import {TeamAppsUiContext} from "../TeamAppsUiContext";
import {UiSplitDirection} from "../../generated/UiSplitDirection";
import {UiSplitSizePolicy} from "../../generated/UiSplitSizePolicy";
import {ItemTreeItem} from "./ItemTree";
import {UiComponent} from "../UiComponent";
import {generateUUID} from "../Common";

export class SplitPaneItem implements ItemTreeItem<UiSplitPane> {
	parent: SplitPaneItem;
	component: UiSplitPane;
	private _firstChild: ItemTreeItem<UiComponent<UiComponentConfig>>;
	private _lastChild: ItemTreeItem<UiComponent<UiComponentConfig>>;

	constructor(parent: SplitPaneItem, splitDirection: UiSplitDirection, sizePolicy: UiSplitSizePolicy, firstChildRelativeSize: number, context: TeamAppsUiContext) {
		this.parent = parent;
		this.component = new UiSplitPane({
			_type: 'UiSplitPaneConfig',
			id: generateUUID(),
			splitDirection: splitDirection,
			sizePolicy: sizePolicy,
			referenceChildSize: firstChildRelativeSize,
			resizable: true,
			fillIfSingleChild: true,
			collapseEmptyChildren: true
		}, context);
	}

	public set firstChild(firstChild: ItemTreeItem<UiComponent<UiComponentConfig>>) {
		this._firstChild = firstChild;
		this._firstChild && (this._firstChild.parent = this);
		this.component.setFirstChildInstance(firstChild ? firstChild.component : null, false);
	}

	public set lastChild(lastChild: ItemTreeItem<UiComponent<UiComponentConfig>>) {
		this._lastChild = lastChild;
		this._lastChild && (this._lastChild.parent = this);
		this.component.setLastChildInstance(lastChild ? lastChild.component : null, false);
	}

	public get firstChild(): ItemTreeItem<UiComponent<UiComponentConfig>> {
		return this._firstChild;
	}

	public get lastChild(): ItemTreeItem<UiComponent<UiComponentConfig>> {
		return this._lastChild;
	}

	get splitDirection(): UiSplitDirection {
		return this.component.splitDirection;
	}

	get sizePolicy(): UiSplitSizePolicy {
		return this.component.sizePolicy;
	}

	get referenceChildSize(): number {
		return this.component.referenceChildSize;
	}
}
